import type { MealTiersMiniEntity } from "@/features/mealTiers/domain/entities/MealTiersMiniEntity"
import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity"

export class BulkCompanyUserEntity {
  companyId!: number
  users?:Array<{
    user?: UserMiniEntity
    mealTier?: MealTiersMiniEntity
    maxItemPerMeal?: number | null
  }>
}
